import React from 'react';

const Image = ({ imageUrl }) => {
  console.log("Image URL:", imageUrl); // Log imageUrl prop for debugging
  return <img src={`https://dosacafe.in/admin/${imageUrl}`} alt="Gallery" />;
};


export default Image;
